import React, {useEffect} from 'react';
import {createBrowserRouter, Outlet, RouterProvider} from "react-router-dom";
import {HomePage} from "./pages/home/home-page";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {ParallaxProvider} from "react-scroll-parallax";
import {PortfolioDataProvider} from "./pages/home/data";
import {moritzData} from "./data/all-data";
import {TooltipProvider} from "./components/ui/tooltip";
import {ImprintPage} from "./pages/imprint/imprint-page";
import {useColorScheme} from "./lib/color-scheme";
import {ContactPage} from "./pages/contact/contact-page";

export const appConfig = {
    title: "Moritz Bruder - Portfolio",
}

const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <PortfolioDataProvider data={moritzData}>
                <TooltipProvider>
                    <ParallaxProvider>
                        <Outlet />
                    </ParallaxProvider>
                </TooltipProvider>
            </PortfolioDataProvider>
        ),
        children: [
            {
                path: "/",
                element: <HomePage />,
            },
            {
                path: "/imprint",
                element: <ImprintPage />,
            },
        ],
    }
]);

function PortfolioApp() {
    useEffect(() => {
        document.title = appConfig.title;
    }, []);
    return <QueryClientProvider client={new QueryClient()}>
        <RouterProvider router={router} />
        <ReactQueryDevtools />
    </QueryClientProvider>
}

function ContactApp() {
    useColorScheme();
    return <ContactPage />
}

const CONTACT_DOMAIN = "links.mbruder.com";
const App = window.location.host === CONTACT_DOMAIN ? ContactApp : PortfolioApp;

export default App;
